import { motion } from "framer-motion"
import React from "react";
import { Link } from "react-router-dom";

const About: React.FC = () => {
    const fadeInVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };
    return (
        <main
            data-aos="fade-up"
            className='tw-h-lvh tw-grid tw-place-items-center tw-w-lvw'>
            <div className='tw-relative tw-grid tw-items-center tw-w-[90vw] tw-h-[80vh] tw-rounded-2xl tw-z-10 lg:tw-text-black tw-overflow-hidden'>
                <div className="tw-h-full tw-w-full tw-absolute tw-bg-[rgba(0,0,0,0.5)] lg:tw-bg-[rgba(0,0,0,0.1)]" />
                <img src="/ContactUs/about.jpg" alt="About Image" className='-tw-z-10 tw-absolute tw-object-cover tw-w-full tw-h-full' />
                <div className="lg:tw-w-[40%] tw-z-10 tw-relative tw-ml-10 lg:tw-ml-32">
                    <motion.p
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInVariant}
                        className="tw-font-medium"
                    >
                        ABOUT US
                    </motion.p>
                    <motion.h1
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInVariant}
                        className="tw-text-6xl tw-mt-6 tw-mb-20 tw-font-semibold">We protect what
                        people love.</motion.h1>
                    <Link to={'/'} className="tw-bg-[#00C5FB] hover:tw-bg-white tw-py-2 tw-px-6 tw-rounded-md">Learn More About Protega</Link>
                </div>
            </div>
        </main>
    )
}

export default About